<template>
    <popup-modal ref="popup">
        <h2 class="font-bold mb-4 text-xl">{{ title }}</h2>
        <div class="mb-4">{{ message }}</div>
        <formcontrol type="dropdown"
                     class="mb-4"
                     placeholder="Укажите причину"
                     v-model.number="reason_id" :options="options"></formcontrol>

        <div v-if="reason_id === 50" class="mb-4">
            <textarea ref="reason" maxlength="120" v-model="reason"
                      class="w-full h-20 input mb-4 focus:outline-none bg-white/10"
                      autofocus></textarea>
        </div>
        <div class="flex items-center justify-between">
            <button class="btn btn-md" @click.prevent="_cancel">{{ cancelButton }}</button>
            <button class="btn btn-md btn-primary" @click.prevent="_confirm">{{ okButton }}</button>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from './PopupModal.vue'
import Formcontrol from "../form/formcontrol";

export default {
	name: 'ComplainDialog',

	components: {Formcontrol, PopupModal},

	data: () => ({
		// Parameters that change depending on the type of dialogue
		title: undefined,
		message: undefined, // Main text content
		okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
		cancelButton: 'Отмена', // text for cancel button
		isPrompt: false,
		reason_id: null,
		reason: null,
		options: [
			{value: 1, label: 'Спам'},
			{value: 2, label: 'Оскорбление'},
			{value: 3, label: 'Нарушение закона'},
			{value: 4, label: 'Порнографический контент'},
			{value: 5, label: 'Насилие'},
			{value: 6, label: 'Нарушение авторских прав'},
			{value: 7, label: 'Введение в заблуждение'},
			{value: 8, label: 'Не соответствует тематике подсайта'},
			{value: 50, label: 'Другое'},
		],
	}),

	methods: {
		show(opts = {}) {
			this.title = opts.title
			this.message = opts.message
			this.okButton = opts.okButton
			this.isPrompt = opts.isPrompt ?? false;

			if (opts.cancelButton) {
				this.cancelButton = opts.cancelButton
			}

			// Once we set our config, we tell the popup modal to open
			this.$refs.popup.open();

			// Return promise so the caller can get results
			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve
				this.rejectPromise = reject
			})
		},

		_confirm() {
			if (this.reason_id && (this.reason_id !== 50 || this.reason.length)) {
				this.$refs.popup.close()
				this.resolvePromise({reason_id: this.reason_id, reason: this.reason})
			}
		},

		_cancel() {
			this.$refs.popup.close()
			this.rejectPromise()
		},
	},
}
</script>